import {cities} from "../constants/constants";

export const citiesToRestrictedCities = (citiesData) => {
    return cities
        .filter(c => !citiesData.includes(c?.name?.toLocaleLowerCase("tr-TR")))
        .map(c => c?.name || "");
};